// Agencias tal y como las tiene la app, para el backoffice: se importan tal
// cual sus archivos (dejan AgenciasShared, AgenciasAgencyProfile… en global)
// y la hoja de estilos de la ficha del Explorador. Así el backoffice usa el
// MISMO catálogo de planes, las mismas condiciones a medida (agencyPlan) y
// pinta la misma cabecera y la misma ficha pública que ven los creadores.
//   shared.js          planes, límites, agencyPlan, planUsageIssues, insignias…
//   region-geo.js      nombre del país de cada región
//   agency-card.js     tarjeta del Explorador (logo, estadísticas, tier)
//   offer-icons.js     iconos de «Qué ofrece»
//   agency-profile.js  ficha «Ver agencia» (fromAgency, heroHtml, sheetHtml, wire)
import './agencyAppI18n.js';
import '../../../renderer/tabs/agencias/shared.js';
import '../../../renderer/tabs/agencias/components/region-geo.js';
import '../../../renderer/tabs/agencias/components/agency-card.js';
import '../../../renderer/tabs/agencias/components/offer-icons.js';
import '../../../renderer/tabs/agencias/views/explorer/agency-profile.js';
import '../../../renderer/styles/views/agency-explorer.css';
import './agencyApp.css';

export const AgencyShared = globalThis.AgenciasShared;
export const AgencyProfile = globalThis.AgenciasAgencyProfile;
export const AgencyCard = globalThis.AgenciasAgencyCard;
export const RegionGeo = globalThis.AgenciasRegionGeo;

// La fuente de la app: con otra, la cabecera de la ficha mide distinto.
export const APP_FONT_URL = 'https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap';

export function ensureAppFont() {
  if (typeof document === 'undefined') return;
  if (document.querySelector(`link[href="${APP_FONT_URL}"]`)) return;
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = APP_FONT_URL;
  document.head.appendChild(link);
}

export const t = (key, fallback) => AgencyShared.t(key, fallback);
